import React from 'react';
import { IIconProps } from './IIconProps';

export const DropIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 28 21"
			className={iconClass}
			fill="none"
		>
			{title && <title>{title}</title>}
			<path
				d="M10.4375 12.2813L14 15.8438M14 15.8438L17.5625 12.2813M14 15.8438V7.53125M14 1C11.9674 1 9.92368 1.76279 8.3739 3.28768C7.22136 4.42172 6.52266 5.82851 6.22639 7.29548C3.21892 7.86956 0.9375 10.4539 0.9375 13.5735C0.9375 17.1128 3.87174 20 7.46875 20H21.3832C24.5148 20 27.0625 17.4931 27.0625 14.4118C27.0625 11.5036 24.7856 9.13616 21.8978 8.87592C21.9112 6.85323 21.1811 4.82641 19.6172 3.28768C18.0688 1.76403 16.0326 1 14 1Z"
				stroke="#000733"
				strokeOpacity="0.24"
			/>
		</svg>
	);
};
